var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cbr-ReturnPlan-outer",style:({color:_vm.pageTextColor,
           backgroundColor:_vm.parcelShopInfoBackgroundColor})},[_c('div',{staticClass:"c-cbr-ReturnPlan-headline"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.headline)))]),_vm._v(" "),_c('div',{staticClass:"c-cbr-ReturnPlan-subHeadline"},[_vm._v("\n    "+_vm._s(_vm.$t('return.free')))]),_vm._v(" "),_c('div',{staticClass:"c-cbr-ReturnPlan-content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d23ac28","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CbrReturnPlan.vue
// module id = 138
// module chunks = 0